<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />安全建议<slot name="right"></slot></h3>
    <div>
      <p>
        驾驶过程中若出现疲劳驾驶、注意力分散等均属于不规范驾驶行为，建议驾驶员在行驶过程中注意规避。
      </p>
      <ul class="advices">
        <li v-for="(item, index) in items" :key="index">
          <h4>{{item.title}}</h4>
          <p v-for="(x,ind) in item.contentList" :key="ind">{{ x }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countContrast",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.item = res.data.data;
        var data = res.data.data;
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr = arr.concat(data[i].adviseList);
        }
        this.items=arr;
      });
    },
  },
  mounted() {},
};
</script>
<style>
.advices{
  margin-top: 20px;
}
.advices li{
  margin-bottom: 20px;
}
.advices li h4{
  font-size: 16px;
  margin-bottom: 6px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/jianyi.vue